// extracted by mini-css-extract-plugin
export var component = "TableModule-module--component--4JGDY";
export var head = "TableModule-module--head--+GEOx";
export var table = "TableModule-module--table--U2A-J";
export var td = "TableModule-module--td--I9fQC";
export var th = "TableModule-module--th--aT7nz";
export var title = "TableModule-module--title--9vYbX";